<template>
  <div class="container mt-3 mt-5 d-flex justify-content-center ">
    <!--    success   UNSUCCESSFUL-->
    <div class="d-flex flex-column card col-md-5 mt-5 text-center" v-if="MethodState(status) == 'UNSUCCESSFUL'">
      <div class="p-2 ">
        <h4 class="">تراکنش با موفقیت انجام شده</h4>
      </div>
      <div class="p-2 mt-4">
        <i class="far fa-check-circle text-success  fa-4x "></i>
      </div>
      <div class=" d-flex justify-content-between mt-3 ">
        <div class="p-2 font-bold"><span>شماره پیگری تراکنش</span></div>
        <div class="p-2"><span>{{ ref_id }}</span></div>
      </div>
      <div class=" d-flex justify-content-between mt-3 ">
        <div class="p-2 font-bold"><span>تاریخ تراکنش</span></div>
        <div class="p-2"><span>{{ dates.converDatePersian(date) }} </span></div>
      </div>
      <div>
        <br>
        <h6>
          برای مشاهد لیست کد های تخفیف
          <router-link to="/agents/panel/discount" class="title  text-danger ">
            <span class="title btn text-danger">اینجا</span>
          </router-link>
          کلیک کنید
        </h6>
      </div>
    </div>
    <!--      errors  UNKNOWN -->
    <div class="d-flex flex-column card col-md-5 mt-5 text-center" v-else-if="MethodState(status) === 'UNKNOWN' ">
      <div class="p-2 mt-2 ">
        <h4 class="text-danger">متاسفانه پرداخت شما ناموفق بود </h4>
      </div>
      <div class="p-2 mt-4">
        <i class="fas fa-exclamation-triangle	 text-danger  fa-3x "></i>
      </div>
      <div class=" d-flex justify-content-between mt-3" v-if="ref_id !=0 ">
        <div class="p-2 font-bold"><span>شماره پیگری تراکنش</span></div>
        <div class="p-2"><span>{{ ref_id }}</span></div>
      </div>
      <div class=" d-flex justify-content-between mt-3" v-if="date != 0 ">
        <div class="p-2 font-bold"><span>تاریخ و ساعت تراکنش</span></div>
        <div class="p-2"><span>{{ dates.DatePersianTime(date) }} </span></div>
      </div>

    </div>
  </div>
</template>
<script setup>
import {useRoute} from 'vue-router'
import * as dates from "../../../common/helpers/DatePersian";
import {$ref} from "vue/macros";
import {useStore} from "vuex";
import {DatePersianTime} from "../../../common/helpers/DatePersian";

const store = useStore()

const route = useRoute()
let status = $ref(route.params.params[0]);
let ref_id = $ref((route.params.params[1]) ? route.params.params[1] : 0);
let date = $ref((route.params.params[2]) ? route.params.params[2] : 0);

function MethodState(status) {
  if (status === "UNSUCCESSFUL") {
    return "UNSUCCESSFUL";
  }
  return "UNKNOWN";
}
store.commit('clearAll');


</script>